/**
 * Bundled paper-tear SFX (`assets/Sounds/ui-paper-tear.mp3`) used by the TicketStub tear-off animation.
 */

import {
  resolveBundledMp3NativeSource,
  resolveBundledMp3UriForWeb,
} from './bundledMp3Module.helper';

// eslint-disable-next-line @typescript-eslint/no-require-imports
const PAPER_TEAR_MODULE = require('../../../assets/Sounds/ui-paper-tear.mp3') as unknown;

export function getNativePaperTearSource(): number | { uri: string } | null {
  return resolveBundledMp3NativeSource(PAPER_TEAR_MODULE);
}

export function getPaperTearBundledUriForWeb(): string | null {
  return resolveBundledMp3UriForWeb(PAPER_TEAR_MODULE);
}
